@use "variables" as *;

.title {
  font-size: $fontSize-m;
  font-weight: normal;
  flex-shrink: 1 !important;
  flex-grow: 0 !important;
}

.subtitle {
  font-size: $fontSize-xs !important;
  font-weight: normal !important;
}

.toggleButton {
  font-size: $fontSize-s !important;
  text-transform: none !important;
}

.itemDiv {
  width: 100%;
  min-height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
